import api, { getCsrfHeaders } from './api';

export interface AgentQuestion {
  id: string; message_id: string; question: string; options: string[];
  answer: string; answered_at: string | null; cancelled_at: string | null;
}
export type QuestionAnswer = { question_id: string; request_id: string } & (
  { option_index: number; text?: never } | { text: string; option_index?: never }
);
export interface Investigation {
  id: string; title: string; workspace: string; workspace_name: string;
  provider: string; model: string; model_label: string; status: string; error: string;
  sample_week: string; version_number: number; created_at: string; run: string;
  messages?: { id: string; role: string; text: string; delivery: string; created_at: string }[];
  questions?: AgentQuestion[];
  events?: { id: number; kind: string; created_at: string }[];
  tools?: { id: number; tool: string; state: string; failed: boolean; created_at: string }[];
  artifacts?: { id: string; title: string; url: string }[];
  cost?: { usd: string | null; basis: string; note?: string };
  working_copy?: { hub: string; carrier: string; version: number; edits: number };
  usage?: { input_tokens?: number; output_tokens?: number; list_cost?: { amount: string; currency: string } };
}
export interface InvestigationInput {
  text: string; request_id: string; model?: string; workspace?: string | null;
  sample_week: string; version_number?: number;
}
export interface InvestigationConfiguration {
  model: string; model_label: string; models: { id: string; label: string }[]; available: boolean;
  daily_cap_usd: string; spent_today_usd: string; turn_cap_usd: string;
  sample_weeks: { id: string; name: string; start_date: string }[];
}
const base = '/agent/v1/investigations/';
async function post<T>(path: string, data: unknown): Promise<T> {
  return (await api.post<T>(path, data, { headers: await getCsrfHeaders() })).data;
}
export const investigationsApi = {
  configuration: async (): Promise<InvestigationConfiguration> => (await api.get(`${base}configuration/`)).data,
  list: async (workspace?: string): Promise<Investigation[]> => (await api.get(base, { params: workspace ? { workspace } : undefined })).data,
  get: async (id: string): Promise<Investigation> => (await api.get(`${base}${id}/`)).data,
  start: (data: InvestigationInput) => post<Investigation>(base, data),
  message: (id: string, text: string, request_id: string) => post<Investigation>(`${base}${id}/message/`, { text, request_id }),
  answer: (id: string, data: QuestionAnswer) => post<Investigation>(`${base}${id}/answer/`, data),
  stop: (id: string) => post<Investigation>(`${base}${id}/stop/`, {}),
};
